import React, { useContext } from "react";
import { useParams } from "react-router-dom";

import StateContext from "common/contexts/state-context";
import useAutoUserGeolocation from "common/customHooks/useAutoUserGeolocation";

import MerchantList from "./MerchantList/MerchantList";
import HomeSearch from "./HomeSearch/HomeSearch";
import SeeMore from "./SeeMore/SeeMore";
import Promotion from "./Promotion/Promotion";
import { Collection } from "../../widgets/Collection/Collection";

const StoreLocator = () => {
  const [state] = useContext(StateContext);
  const { slug } = useParams();

  const autoUserGeolocationURL = useAutoUserGeolocation();

  if (autoUserGeolocationURL) {
    window.location.href = autoUserGeolocationURL;
    return null;
  }

  return (
    <>
      {state.sl && (
        <div style={{ paddingTop: "var(--nav-height)" }} className="sl-bg-fag">
          <HomeSearch withGoTo={!!slug} isLocationPage={!!slug}></HomeSearch>
          <main>
            {!state.sl.home_search && <MerchantList></MerchantList>}
            <SeeMore></SeeMore>
            <Promotion></Promotion>
            <Collection
              style={{
                backgroundColor: "var(--primary-color)",
                padding: "20px 0",
              }}
            ></Collection>
          </main>
        </div>
      )}
    </>
  );
};

export default StoreLocator;
